"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeStyles = exports.buildMediaQuery = void 0;
var _deepmerge = _interopRequireDefault(require("deepmerge"));
var buildMediaQuery = function buildMediaQuery(breakpoint) {
  var useMediaPrefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var min = breakpoint.min,
    max = breakpoint.max;
  var minQuery = min ? "and (min-width: ".concat(min, "px)") : '';
  var maxQuery = max ? "and (max-width: ".concat(max, "px)") : '';
  var mediaPrefix = useMediaPrefix ? '@media' : '';
  return "".concat(mediaPrefix, " screen ").concat(minQuery, " ").concat(maxQuery).trim();
};
exports.buildMediaQuery = buildMediaQuery;
var mergeStyles = function mergeStyles(originalStyles, newStyles) {
  return (0, _deepmerge.default)(originalStyles, newStyles);
};
exports.mergeStyles = mergeStyles;